import { trackAddToCart } from '../../../../../../shared/analytics/e-commerce/trackAddToCart';
import { IParkingProduct } from '../../../../../domain/parking-product/models/IParkingProduct';
import { adaptParkingProductToItem } from './adapters/adaptParkingProductToItem';

export function trackSelectProduct(selectedParkingProduct: IParkingProduct) {
	trackAddToCart({
		items: [adaptParkingProductToItem(selectedParkingProduct)],
	});
}
